import {
    createFailure,
    validationFailed,
    ValidationFailure,
    ValidationResult,
    validationSuccessful
} from "sprint-common-web";

export const validateAsperaKey = (asperaKey: string): ValidationResult => {
    const failure: ValidationFailure = createFailure(
        "Smm private key name should have construct: '/ord/manual/{name}-aspera-key', where '{name}' should be key name",
        "SsmPrivateKeyName.IncorrectConstruct"
    );

    const failed = validationFailed([failure]);

    if (!asperaKey.startsWith("/")) {
        return failed;
    }

    const asperaKeyParts = asperaKey.split("/");

    if (asperaKeyParts.length !== 4) {
        return failed;
    }

    if (!containsOrdPart(asperaKeyParts)) {
        return failed;
    }

    if (!containsManualPart(asperaKeyParts)) {
        return failed;
    }

    if (!hasCorrectKeyName(asperaKeyParts)) {
        return failed;
    }

    return validationSuccessful();
};

const containsOrdPart = (asperaKeyParts: string[]) => asperaKeyParts[1] === "ord";

const containsManualPart = (asperaKeyParts: string[]) => asperaKeyParts[2] === "manual";

const hasCorrectKeyName = (asperaKeyParts: string[]) => {
    const asperaKeyNameParts = asperaKeyParts[3].split("-");

    if (asperaKeyNameParts.length !== 3) {
        return false;
    }

    return asperaKeyNameParts[0].length && asperaKeyNameParts[1] === "aspera" && asperaKeyNameParts[2] === "key";
};
